import React from 'react';
import { CommentEnd, DoubleCommentEnd, CommentStart, DoubleCommentStart, } from '../components/comments';
import { useConfig } from '../components/config-context';
import { Text } from '../components/text';
export const GenericImage = ({ src, cssClass = '', width = 'auto', align = 'center', href, style, probableWidth, probableHeight, imgStyle = {}, alt, height, override, overrideProps, showAfterLoad, paddingLeft, paddingRight, imagePaddingLeft, imagePaddingRight, }) => {
    const imageMaxWidth = parseInt(width, 10)
        ? `${parseInt(width, 10)}px`
        : '100%';
    const { implementations } = useConfig();
    const wrapperDefaultProps = {
        className: cssClass,
        style: {
            display: 'inline-block',
            maxWidth: imageMaxWidth,
            paddingLeft: imagePaddingLeft,
            paddingRight: imagePaddingRight,
            ...style,
        },
    };
    const outlookHeight = height ? { height } : {};
    const props = href
        ? { ...wrapperDefaultProps, href, target: '_blank' }
        : wrapperDefaultProps;
    return (React.createElement(Text, { align: align, padding: "0px", paddingLeft: paddingLeft, paddingRight: paddingRight, override: override, overrideProps: overrideProps },
        React.createElement("a", { ...props },
            React.createElement(implementations.Image, { src: src, width: probableWidth || width, ...outlookHeight, style: {
                    display: 'inline-block',
                    maxWidth: '100%',
                    width,
                    verticalAlign: 'middle',
                    ...imgStyle,
                }, alt: alt || '', probableHeight: probableHeight, showAfterLoad: showAfterLoad }))));
};
export const GenericImageWithSplitResolutionsForOutlook = (props) => {
    const { align = 'center', override, overrideProps, renderWithText } = props;
    if (renderWithText) {
        return (React.createElement(Text, { align: align, padding: "0px", override: override, overrideProps: overrideProps },
            React.createElement(GenericImageContent, { ...props })));
    }
    return (React.createElement("div", { style: { textAlign: align } },
        React.createElement(GenericImageContent, { ...props })));
};
export const GenericImageContent = ({ src, srcNonRetina, cssClass = '', href, maxHeight, width = 'auto', alt, showAfterLoad, probableWidth, imgStyle = {}, probableHeight, height, }) => {
    const imageMaxWidth = parseInt(width, 10)
        ? `${parseInt(width, 10)}px`
        : '100%';
    const wrapperDefaultProps = {
        className: cssClass,
        style: {
            display: 'inline-block',
            maxWidth: imageMaxWidth,
            maxHeight,
        },
    };
    const props = href
        ? { ...wrapperDefaultProps, href, target: '_blank' }
        : wrapperDefaultProps;
    const commonImageProps = {
        width: 'auto',
        style: {
            display: 'inline-block',
            maxWidth: '100%',
            width: 'auto',
            verticalAlign: 'middle',
            maxHeight,
            ...imgStyle,
        },
    };
    const { renderComments, implementations } = useConfig();
    return (React.createElement("a", { ...props },
        renderComments && (React.createElement(React.Fragment, null,
            React.createElement(CommentStart, { condition: "if mso" }),
            React.createElement("img", { src: srcNonRetina, ...commonImageProps, width: probableWidth || width, height: height, alt: alt || '' }),
            React.createElement(CommentEnd, null))),
        React.createElement(DoubleCommentStart, { condition: "if !mso" }),
        React.createElement(implementations.Image, { src: src, ...commonImageProps, alt: alt || '', probableHeight: probableHeight ?? (maxHeight ? parseInt(maxHeight, 10) : undefined), showAfterLoad: showAfterLoad }),
        React.createElement(DoubleCommentEnd, null)));
};
//# sourceMappingURL=generic-image.js.map